<template>
  <div class="login-layout">
    <router-view></router-view>
  </div>
</template>
<script>
import login from "./mixins/login";
import error from "./mixins/error";
export default {
  mixins: [login, error],
};
</script>
<style scoped>
.login-layout {
  width: 100%;
  height: 100%;
}
</style>
